import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {ngStorage} from "ngstorage";
import StorageService = ngStorage.StorageService;

export default class ListController implements Ng1Controller {

    $onInit(): void {
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService,
                private $localStorage: StorageService,
                private $state: StateService,
                private $stateParams: any) {
    }

    get filterActive() {
        return this.$localStorage.txnTemplateFilterActive;
    }

    set filterActive(value: boolean) {
        this.$localStorage.txnTemplateFilterActive = value;
    }

    get filterReview() {
        return this.$localStorage.txnTemplateFilterReview;
    }

    set filterReview(value: boolean) {
        this.$localStorage.txnTemplateFilterReview = value;
    }

}
